import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PhoneLabel, PhoneValue } from 'server-model';

@Component({
  selector: 'app-single-phone-input',
  templateUrl: './single-phone-input.component.html',
  styleUrl: './single-phone-input.component.scss'
})
export class SinglePhoneInputComponent {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() value: PhoneValue[] = [];
  @Input() required: boolean = false;
  @Input() hideOptional: boolean = false;
  @Input() error: boolean = false;
  @Input() disabled: boolean = false;
  @Input() inlineInfo: string = '';
  @Input() errorText: string = 'This field is required.';
  @Input() showLabel: boolean = true;
  @Output() valueChange = new EventEmitter<PhoneValue[]>();
  @Output() isFieldInvalid = new EventEmitter<boolean>();


  updateValue(value: string) {
    const isValidPhone = this.isValidPhone(value);
    if (!isValidPhone) {
      this.error = true;
      this.errorText = 'Please enter a valid phone number.';
      this.isFieldInvalid.emit(true);
    } else {
      this.error = false;
      this.errorText = 'This field is required.';
      let phoneValue: PhoneValue[] = value ? [{ label: PhoneLabel.WORK, value: value, primary: true }] : [];
      this.value = phoneValue;
      this.valueChange.emit(this.value);
      this.isFieldInvalid.emit(false);
    }
  }


  isValidPhone(value: string) {
    // This regex checks for an optional leading sign, digits, optional decimal, and optional digits after the decimal.
    const regex = /^[0-9+\-()/\s]*$/;
    return regex.test(value);
  }
}
